import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray"; // @ts-check

import produce from 'immer';
import { csvItemsPerPage } from '../constants';

function reducer(state, action) {
  switch (action.type) {
    case 'csvData_page_fetched':
      return addPage(state, action.payload);

    case 'csvData_row_removed':
      return removeRow(state, action.payload);

    case 'csvData_row_added':
      return addRow(state, action.payload);

    case 'csvData_cell_modified':
      return modifyCell(state, action.payload);

    case 'document_saved':
      return setModifiedRowsSaved(state);

    default:
      return state;
  }
}

var addPage = function addPage(state, _ref) {
  var path = _ref.path,
      pageIndex = _ref.pageIndex,
      csvData = _ref.csvData;
  return produce(state, function (draft) {
    if (draft[path] === undefined) {
      draft[path] = {
        pagesMap: {},
        edits: null,
        serverModifiedRows: null
      };
    }

    draft[path].header = csvData.Data[0];
    draft[path].totalCount = csvData.TotalCount;
    draft[path].pagesMap[pageIndex] = csvData.Data.slice(1);
  });
};

var removeRow = function removeRow(state, _ref2) {
  var path = _ref2.path,
      pageIndex = _ref2.pageIndex,
      rowIndex = _ref2.rowIndex;
  return produce(state, function (draft) {
    var csvRowIndex = pageIndex * csvItemsPerPage + rowIndex;
    if (draft[path].edits === null) draft[path].edits = {
      removedRows: [],
      modifiedRows: {},
      addedRows: []
    };

    if (csvRowIndex < draft[path].totalCount) {
      draft[path].edits.removedRows.push(csvRowIndex);
    } else {
      // removed row is newly added
      var indexInAddedRows = csvRowIndex - draft[path].totalCount;
      draft[path].edits.addedRows.splice(indexInAddedRows, 1);
    }
  });
};

var addRow = function addRow(state, _ref3) {
  var path = _ref3.path;
  return produce(state, function (draft) {
    if (draft[path].edits === null) draft[path].edits = {
      removedRows: [],
      modifiedRows: {},
      addedRows: []
    };
    draft[path].edits.addedRows.push(new Array(draft[path].header.length));
  });
};

var modifyCell = function modifyCell(state, _ref4) {
  var path = _ref4.path,
      pageIndex = _ref4.pageIndex,
      rowIndex = _ref4.rowIndex,
      columnIndex = _ref4.columnIndex,
      value = _ref4.value;
  return produce(state, function (draft) {
    var csvRowIndex = pageIndex * csvItemsPerPage + rowIndex;
    if (draft[path].edits === null) draft[path].edits = {
      removedRows: [],
      modifiedRows: {},
      addedRows: []
    };

    if (csvRowIndex < draft[path].totalCount) {
      if (draft[path].edits.modifiedRows[csvRowIndex] === undefined) {
        draft[path].edits.modifiedRows[csvRowIndex] = _toConsumableArray(draft[path].pagesMap[pageIndex][rowIndex]);
      }

      draft[path].edits.modifiedRows[csvRowIndex][columnIndex] = value;
    } else {
      // edited row is newly added
      var indexInAddedRows = csvRowIndex - draft[path].totalCount;
      draft[path].edits.addedRows[indexInAddedRows][columnIndex] = value;
    }
  });
};

var setModifiedRowsSaved = function setModifiedRowsSaved(state) {
  return produce(state, function (draft) {
    Object.keys(draft).forEach(function (key) {
      return delete draft[key];
    });
  });
};

export var isCsvDataModifyAction = function isCsvDataModifyAction(type) {
  switch (type) {
    case 'csvData_cell_modified':
    case 'csvData_row_removed':
    case 'csvData_row_added':
      return true;

    default:
      return false;
  }
};
export default reducer;